document.addEventListener('DOMContentLoaded', function () {

    console.log('schoollookup');
  if (document.querySelector('#school_lookup')) {
    const schoolSelect = new SlimSelect({
      select: '.school-selector select',
      settings: {
        searchPlaceholder: 'Please enter 3 or more characters',
        placeholderText: 'Enter School Name or Postcode'
      },
      events: {
        afterChange: newVal => {
          updateFormFields(newVal);
        },
        search: (search, currentData) => {
          return new Promise((resolve, reject) => {
            if (search.length < 3) {
              return reject('Please enter 3 or more characters');
            }
            const data =  'transform=1&&satisfy=any&filter1[]=EstablishmentName,cs,'+search+'&filter2[]=Postcode,sw,'+search;
            const queryParams = new URLSearchParams(data);
            const url = `https://schools.igoodev.com/api/records/schools?${queryParams}`;
            fetch(url, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json'
              }
            }).then(response => response.json()).then(resp => {
              const data = resp?.records || [];
              if (!data.length) {
                return reject(resp?.error || 'No results found');
              }
              const options = data.filter(school => {
                return (school.EstablishmentStatus == 'Open' || school.EstablishmentStatus == 'Proposed to open') && !currentData.some(dataItem => {
                  return dataItem instanceof Option && dataItem.value === `${school.URN}`;
                });
              }).map(school => {
                return {
                  text: `${school.EstablishmentName} ${school.Street}, ${school.Town}, ${school.Postcode}`,
                  value: `${school.URN}`,
                  html: `<b>${school.EstablishmentName}</b><span style="display: block">${school.Street}, ${school.Town}, ${school.Postcode}</span>`,
                  data: school
                };
              });
              resolve([{
                label: 'Results',
                selectAll: true,
                options: options
              }]);
            }).catch(error => {
              console.log(error);
              reject('Error fetching results');
            });
          });
        }
      }
    });
  }

    function updateFormFields(data) {
        let dataArr = Object.entries(data[0].data);
        console.log(dataArr)
        dataArr.forEach(val => {
            if(document.querySelector('[data-lookup="'+val[0]+'"]')) {
                document.querySelector('[data-lookup="'+val[0]+'"]').value = val[1];
            }
        });
    }

  if(document.querySelector('#input_6_9')) {
    const schoolSelect = new SlimSelect({
      select: '#input_6_9',
      settings: {
        searchPlaceholder: 'Please enter 3 or more characters',
        placeholderText: 'Enter School Name or Postcode'
      },
      events: {
        afterChange: newVal => {
          fillinurn(newVal);
        },
        search: (search, currentData) => {
          return new Promise((resolve, reject) => {
            if (search.length < 3) {
              return reject('Please enter 3 or more characters');
            }
            const data =  'transform=1&&satisfy=any&filter1[]=EstablishmentName,cs,'+search+'&filter2[]=Postcode,sw,'+search;
            const queryParams = new URLSearchParams(data);
            const url = `https://schools.igoodev.com/api/records/schools?${queryParams}`;
            fetch(url, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json'
              }
            }).then(response => response.json()).then(resp => {
              const data = resp?.records || [];
              if (!data.length) {
                return reject(resp?.error || 'No results found');
              }
              const options = data.filter(school => {
                return (school.EstablishmentStatus == 'Open' || school.EstablishmentStatus == 'Proposed to open') && !currentData.some(dataItem => {
                  return dataItem instanceof Option && dataItem.value === `${school.URN}`;
                });
              }).map(school => {
                return {
                  text: `${school.EstablishmentName} ${school.Street}, ${school.Town}, ${school.Postcode}`,
                  value: `${school.URN}`,
                  html: `<b>${school.EstablishmentName}</b><span style="display: block">${school.Street}, ${school.Town}, ${school.Postcode}</span>`,
                  data: school
                };
              });
              resolve([{
                label: 'Results',
                selectAll: true,
                options: options
              }]);
            }).catch(error => {
              console.log(error);
              reject('Error fetching results');
            });
          });
        }
      }
    });
  }
  if(document.querySelector('#input_2_1')) {
    const schoolSelect = new SlimSelect({
      select: '#input_2_1',
      settings: {
        searchPlaceholder: 'Please enter 3 or more characters',
        placeholderText: 'Enter School Name or Postcode'
      },
      events: {
        afterChange: newVal => {
          fillinurn(newVal);
        },
        search: (search, currentData) => {
          return new Promise((resolve, reject) => {
            if (search.length < 3) {
              return reject('Please enter 3 or more characters');
            }
            const data =  'transform=1&&satisfy=any&filter1[]=EstablishmentName,cs,'+search+'&filter2[]=Postcode,sw,'+search;
            const queryParams = new URLSearchParams(data);
            const url = `https://schools.igoodev.com/api/records/schools?${queryParams}`;
            fetch(url, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json'
              }
            }).then(response => response.json()).then(resp => {
              const data = resp?.records || [];
              if (!data.length) {
                return reject(resp?.error || 'No results found');
              }
              const options = data.filter(school => {
                return (school.EstablishmentStatus == 'Open' || school.EstablishmentStatus == 'Proposed to open') && !currentData.some(dataItem => {
                  return dataItem instanceof Option && dataItem.value === `${school.URN}`;
                });
              }).map(school => {
                return {
                  text: `${school.EstablishmentName} ${school.Street}, ${school.Town}, ${school.Postcode}`,
                  value: `${school.URN}`,
                  html: `<b>${school.EstablishmentName}</b><span style="display: block">${school.Street}, ${school.Town}, ${school.Postcode}</span>`,
                  data: school
                };
              });
              resolve([{
                label: 'Results',
                selectAll: true,
                options: options
              }]);
            }).catch(error => {
              console.log(error);
              reject('Error fetching results');
            });
          });
        }
      }
    });
  }

  function fillinurn(data) {
        let dataArr = Object.entries(data[0].data);
        console.log(dataArr)
        dataArr.forEach(val => {
            if(val[0] == 'URN') {
                console.log(val[1])
                document.querySelector('.URN input').value = val[1];
            }
            if(document.querySelector('[data-lookup="'+val[0]+'"]')) {
                document.querySelector('[data-lookup="'+val[0]+'"]').value = val[1];
            }
        });
  }
});
